// modules
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

// components
import { SystemModulesComponent } from './system-modules.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ComponentsModule } from '../../components/component.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { ActionsTableModule } from 'projects/access-control/src/app/UI/commons/actions-table/actions-table.module';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { PipesModule } from 'projects/access-control/src/app/Infrastructure/pipes/pipes.module';
import { SubSidebarModule } from 'projects/access-control/src/app/UI/commons/sub-sidebar/sub-sidebar.module';
import { loadingSpinnerModule } from 'projects/access-control/src/app/UI/commons/loading-spinner/loading-spinner.module';
import { DirectivesModule } from 'projects/access-control/src/app/Infrastructure/directive/directives.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LayoutTableModule } from 'projects/access-control/src/app/UI/commons/layout-table/layout-table.module';
import { CommonsModule } from 'projects/access-control/src/app/UI/commons/commons.module';
import { VersionsComponent } from './components/versions/versions.component';
import { ResourcesComponent } from './components/resources/resources.component';

const routes: Routes = [
	{
		path: '',
		component: SystemModulesComponent,
	},
];

@NgModule({
	declarations: [SystemModulesComponent, VersionsComponent, ResourcesComponent],
	exports: [SystemModulesComponent],
	imports: [
		CommonModule,
		RouterModule.forChild(routes),
		NgxDatatableModule,
		ComponentsModule,
		LayoutTableModule,
		CommonsModule,
		SubSidebarModule,
		MatIconModule,
		PipesModule,
		PipesModule,
		MatDialogModule,
		ActionsTableModule,
		FormsModule,
		MenuModule,
		MatTooltipModule,
		loadingSpinnerModule,
		DirectivesModule,
	],
	providers: [DatePipe],
})
export class SystemModulesModule {}
